"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Policy = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const policy_tpa_map_entity_1 = require("./policy-tpa-map.entity");
const policy_insurer_map_entity_1 = require("./policy-insurer-map.entity");
const policy_covers_map_entity_1 = require("./policy-covers-map.entity");
const policy_cd_number_map_entity_1 = require("./policy-cd-number-map.entity");
const policy_premium_installment_schedules_entity_1 = require("./policy-premium-installment-schedules.entity");
const company_entity_1 = require("./company.entity");
const opportunity_entity_1 = require("./opportunity.entity");
let Policy = class Policy {
};
exports.Policy = Policy;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "policy_name",
        type: "varchar",
        length: 255,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Policy.prototype, "policyName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "policy_type",
        type: "varchar",
        length: 255,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], Policy.prototype, "policyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_from", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Policy.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_to", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Policy.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "provisional_policy_no",
        type: "varchar",
        length: 255,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], Policy.prototype, "provisionalPolicyNo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sum_insured", type: "decimal", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "premium_at_inception", type: "decimal", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "premiumAtInception", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "service_tax", type: "decimal", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "serviceTax", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "gst", type: "decimal", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "gst", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_policy_number",
        type: "varchar",
        length: 255,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], Policy.prototype, "insurerPolicyNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "commission_terrorism", type: "decimal", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "commissionTerrorism", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_configuration", type: "json", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], Policy.prototype, "policyConfiguration", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "configuration_status_lid",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "configurationStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "enrollment_status_lid",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "enrollmentStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "policyStatusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Policy.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Policy.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Policy.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({
        name: "opportunity_id",
        referencedColumnName: "opportunityId",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], Policy.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], Policy.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_tpa_map_entity_1.PolicyTpaMap, (policyTpaMap) => policyTpaMap.policy),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], Policy.prototype, "tpaMappings", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_insurer_map_entity_1.PolicyInsurerMap, (policyInsurerMap) => policyInsurerMap.policy),
    tslib_1.__metadata("design:type", typeof (_j = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _j : Object)
], Policy.prototype, "insurerMappings", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_covers_map_entity_1.PolicyCoverMap, (policyCoverMap) => policyCoverMap.policy),
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], Policy.prototype, "coverMappings", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_cd_number_map_entity_1.PolicyCdNumberMap, (policyCdNumberMap) => policyCdNumberMap.policy),
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], Policy.prototype, "cdMappings", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_premium_installment_schedules_entity_1.PolicyPremiumInstallmentSchedule, (installment) => installment.policy),
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], Policy.prototype, "premiumInstallments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "configuration_status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_o = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _o : Object)
], Policy.prototype, "configurationStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "enrollment_status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_p = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _p : Object)
], Policy.prototype, "enrollmentStatus", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_q = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _q : Object)
], Policy.prototype, "policyStatus", void 0);
exports.Policy = Policy = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy")
], Policy);
